import { Controller } from "@hotwired/stimulus"

// Remembers which items of an article checklist this browser has ticked.
export default class extends Controller {
  static values = { storageKey: String }

  connect() {
    let checked
    try { checked = JSON.parse(localStorage.getItem(this.key) || "[]") } catch { return }
    if (!Array.isArray(checked)) return

    this.checkboxes.forEach((checkbox, index) => { checkbox.checked = checked.includes(index) })
  }

  save() {
    const checked = this.checkboxes.flatMap((checkbox, index) => (checkbox.checked ? [ index ] : []))
    try { localStorage.setItem(this.key, JSON.stringify(checked)) } catch {}
  }

  get checkboxes() {
    return [ ...this.element.querySelectorAll("input[type=checkbox]") ]
  }

  get key() {
    return `checklist:${window.location.pathname}:${this.storageKeyValue}`
  }
}
